export const basicDetailsImageUploadStyle = theme => ({
    textFieldUpload: {
        marginTop: 8,
        marginBottom: 8
    },
    upload: {
        display: 'none'
    },
    labelButton: {
        width: '100%',
        marginTop: '16px'
    }
})